import React, { useMemo, useState } from 'react';

import { Checkbox } from '@atlaskit/checkbox';
import SectionMessage, { SectionMessageAction } from '@atlaskit/section-message';

const CheckboxedSection = ({ name, value, onChange, onBlur, label, children, helpMessage }) => {
  const [collapsed, setCollapsed] = useState(false);
  const boolValue = Boolean(value);

  const actions = useMemo(() => {
    if (!boolValue) return [];
    if (collapsed) {
      return [
        <SectionMessageAction
          key="expand"
          href="#"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCollapsed(false); }}
        >
          expand section
        </SectionMessageAction>
      ];
    } else {
      return [
        <SectionMessageAction
          key="collapse"
          href="#"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setCollapsed(true); }}
        >
          collapse section
        </SectionMessageAction>
      ];
    }
  }, [collapsed, boolValue]);

  const Icon = useMemo(() => () => (
    <div><Checkbox
      isChecked={boolValue}
      name={name}
      onChange={onChange}
      onBlur={onBlur}
    /></div>
  ), [boolValue, name, onBlur, onChange]);

  const show = !collapsed && boolValue;

  return (
    <div style={{ paddingTop: 30 }}>
      <div>
        <SectionMessage title={label} icon={Icon} actions={actions}>
          {show && helpMessage}
        </SectionMessage>
      </div>
      {show && <div style={{ paddingTop: '10px' }}>{children}</div>}
    </div>
  );
};

export default CheckboxedSection;
